import { securedAxios } from "../lib/axios";
import _ from "lodash";
import urljson from "../lib/urljson";
import { unmaskCPF } from "../lib/masks";

export default {
  namespaced: true,
  state: {
    clientes: [],
  },
  mutations: {
    carregar(state, lista) {
      state.clientes = [];
      state.clientes = lista;
    },
  },
  actions: {
    async listar({ commit }, opts) {
      const opcoes = _.cloneDeep(opts);
      if (opcoes.filtros && opcoes.filtros.cpf_cnpj) {
        opcoes.filtros.cpf_cnpj = opcoes.filtros.cpf_cnpj.replace(/[^\d]/g, "");
      }
      if (opcoes.filtros && opcoes.filtros.pesquisa) {
        opcoes.pesquisa = _.clone(opcoes.filtros.pesquisa);
        delete opcoes.filtros.pesquisa;
      }
      try {
        const response = await securedAxios.get(
          `/clientes?opcoes=${urljson(opcoes)}`
        );
        commit("carregar", response.data);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async gravar(context, data) {
      try {
        let response;
        const dados = {
          ...data,
          cpf_cnpj: unmaskCPF(data.cpf_cnpj),
        };
        if (dados.id === "") {
          delete dados.id;
          response = await securedAxios.post("/clientes", dados);
        } else {
          delete dados.id_entidade;
          response = await securedAxios.put(`/clientes/${dados.id}`, dados);
        }

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    carregar(context, id) {
      return securedAxios.get(`/clientes/${id}`);
    },
    deletar(context, id) {
      try {
        const response = securedAxios.delete(`/clientes/${id}`);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
